import React, { useEffect, useRef } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { setCartOpen } from '../store/cartSlice'
import CartItems from './CartItems.jsx'
import CartBottom from './CartBottom.jsx'

const CartDrawer = (data) => {
  const dispatch = useDispatch()
  const { cart, open, upsells } = useSelector((state) => state.cart)

  const drawerContainer = useRef(null)
  
  useEffect(() => {
    // drawerContainer.current.addEventListener('click', (e) => e.stopPropagation())
    drawerContainer.current.querySelector('[data-cart-close]').addEventListener('click', (e) => dispatch(setCartOpen(false)))
  }, [])

  const drawer = document.querySelector('[data-cart-drawer]')
  drawer.classList.toggle('z-[-1]', !open)
  drawer.classList.toggle('opacity-0', !open)
  drawer.classList.toggle('z-50', open)
  drawer.classList.toggle('opacity-100', open)
  document.body.classList.toggle('overflow-hidden', open)

  // document.querySelector('[data-cart-drawer]').addEventListener('click', () => dispatch(setCartOpen(false)))

  return (
    <div className={`h-full absolute w-full lg:w-[30.5rem] bg-white text-second transition duration-300 ease-in-out px-3 lg:px-10 pt-6 pb-10 ${open ? 'right-0' : 'right-[-31rem]'}`} ref={drawerContainer}>
      <div className="flex items-center justify-between">
        <span className="text-second">
          Cart&nbsp;&nbsp;
          <sup className="text-second text-[0.625rem]">{ cart.item_count }</sup>
        </span>
        <button className="text-second" 
          data-cart-close
          aria-label='Close the cart'
          dangerouslySetInnerHTML={{ __html: window.globalIcons['icon-close'] }}
          />
      </div>
      <div className="h-[calc(100%-1.5rem)] pt-10 text-second flex flex-col justify-between overflow-auto">
        { cart.item_count == 0 && <div className='mt-10 text-second text-center w-full'>
            You Cart Is Empty.
            <a className='mt-6 button w-full !bg-black !text-white !border-black hover:!bg-white hover:!border-black hover:!text-black' href='/'>
              Shop Now
            </a>
          </div>
        }
        
        { cart.item_count > 0 && 
          <div className='h-full overflow-auto'>
            <CartItems />
            
            <div className={`related-products related-products--cartdrawer border-t border-[rgba(33,33,33,0.25)] pt-6 relative overflow-hidden !opacity-100 ${upsells.length > 0 ? '' : 'hidden'}`}>
              {data.data.recommendationHeading && <div className='text-base text-black mb-6' dangerouslySetInnerHTML={{ __html: data.data.recommendationHeading }} />}
              <div data-inline-cart-swiper>
                <div className={`swiper-wrapper !static ${data.data.xgenId ? 'XGen_SmartElement' : ''}`} id={`XSE-${data.data.xgenId}`}>
                  {
                    upsells.map((product, index) =>
                      <div className="swiper-slide" key={`cart-rec-${product.id}-${index}`}>
                        <div className="h-full" product-tile="true" props={JSON.stringify(product).replace("'", "’")}></div>
                      </div>
                    )
                  }
                </div>
                {upsells.length > 1 && <div className="swiper-button-prev !text-second !h-auto after:!hidden !top-6 !right-12 !mt-0 !left-auto !hidden lg:!flex" dangerouslySetInnerHTML={{ __html: window.globalIcons['icon-arrow'] }} />}
                {upsells.length > 1 && <div className="swiper-button-next !text-second !h-auto after:!hidden !top-6 !right-0 !mt-0 !left-auto !hidden lg:!flex" dangerouslySetInnerHTML={{ __html: window.globalIcons['icon-arrow-right'] }} />}
              </div>
            </div>
          </div> 
        }

        { cart.item_count > 0 && <CartBottom /> }
      </div>
    </div>
  )
}

export default CartDrawer